<template>
 <meta charset="utf-8">
    <link rel="shortcut icon" type="image/png" href="/static/favicon.png"/>
    <title>Namaste Nepal </title>
<div class="flex flex-col">
<header v-if ="getShowHeader" class=" text-center">
  <nav class="flex items-center justify-between flex-wrap mx-auto p-6 bg-namasteGreen rounded">
    <div class="flex flex-col md:flex-row container max-w-6xl  justify-between items-center mx-auto text-center">
        <div class="w-full md:w-auto md:mb-0 text-center md:text-left">
        <a href="https://www.namastenepal.de/"
        class="inline-block no-underline text-sm md:py-2 px-3">
            <img
              src="https://namastenepal.de/_images/namaste_nepal_logo.png"
              class="w-40 "
            />
          </a>
          </div>
            <!-- starts here   -->
        <div class="flex  flex-row items-center w-full md:w-auto md:mb-0 text-center md:text-left">
          <a href="#" class="block w-full text-center md:text-left md:w-auto text-gray-600 no-underline flex justify-center items-center">
          <h1 class="text-gray-800 text-center font-medium">
             <span class="sm:text-xl md:text-3xl font-semibold text-namasteRed" >
              Ayurvedisches Restaurant</span><br>
                <span class="text-blue-800 font-medium"> Namaste Nepal </span>
                </h1>

          </a>

        </div>
            <!-- net div ends here  -->
        <div class="w-full md:w-auto mt-1 md:mt-3 py-3 md:py-0
          text-center md:text-right rounded-md text-namasteBlue"
        >
         <!-- :to="{
                    name: 'Home1',
                    params:{slug: ''}
                    }"
                     -->
          <a href="https://www.namastenepal.de/"
            class="w-24 text-center rounded-md  inline-block no-underline bg-blueGray-100
            hover:bg-lightBlue-700 hover:text-white text-sm py-2 px-3 font-bold"
          >
           home
          </a>
        </div>
            <!-- Here ends the next div  -->

      </div>
        <!-- Hamburger menu in the right  -->
        <div class="block lg:hidden absolute sm:relative mx-auto text-center right-4 sm:right-0">
              <button type="button"
                class="block lg:hidden text-right m-atuo navbar-burger
                flex items-center px-4 py-4 border-gray-200 rounded-sm hover:text-white hover:border-white "
                v-on:click="isMenuOpen=!isMenuOpen"
              >
                <svg   v-if ="!isMenuOpen" class="fill-current h-8 w-5 text-3xl"
                  viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Menu</title>
                  <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/>
               </svg>
                <span v-if="isMenuOpen" class="text-3xl text-black" >X</span>
              </button>
        </div>
        <!-- Here is the header menu and dropdown menu
         -->
    </nav>
     <div class="md:block rounded-md md:rounded-none w-full bg-blueGray-200 md:pt-0 px-1
      shadow-lg relative z-1 border-t border-b border-blueGray-300">
      <div :class="isMenuOpen ? 'block':'hidden'" class="px-4 ">
          <!-- //test -->
      </div>
     </div>

   <!-- Header is finished here. We put the list  -->
  <!-- routers are given below  -->
   <!-- <div>
     <article-list> </article-list>
   </div> -->

  <!-- <router-link to="/">Home</router-link> | -->
  <!-- <router-link to="/about">About</router-link> -->
    <!-- <transition name="leave"> -->
      <selection-menu
     :gruppe="getGruppe"
     :gruppenUrls ="getUrls">
    </selection-menu>
    <!-- </transition> -->
</header>

  <!-- until here is header  -->
    <div class="p-2 border border-warmGray-200">
      <router-view v-slot="{ Component}" >
        <transition name="moveUp">
          <keep-alive>
            <component :is="Component" :key='$route.params.slug'/>
          </keep-alive>
        </transition>
      </router-view>
    <!-- <router-view >        </router-view> -->

    </div>

</div>
</template>
<script>
// import ArticleList from '@/views/ArticleList'
import SelectionMenu from '@/components/SelectionMenu.vue'
import {
  mapGetters,
  mapActions
}
  from 'vuex'
export default {
  // metaInfo: {
  //   // if no subcomponents specify a metaInfo.title, this title will be used
  //   title: 'Default Title',
  //   // all titles will be injected into this template
  //   titleTemplate: '%s | My Awesome Webapp',

  //   meta: [
  //     { charset: 'utf-8' },
  //     { name: 'description', content: 'An example Vue application with vue-meta.' },
  //     { name: 'viewport', content: 'width=device-width, initial-scale=1' }
  //   ]
  // },
  data () {
    return {
      isMenuOpen: false,
      isRechnung: false
    }
  },
  components: {
    // ArticleList
    SelectionMenu
  },
  computed: {
    ...mapGetters([
      'getAllProducts',
      'getGruppe',
      'getGruppenUrls',
      'getShowHeader'
    ]),
    getUrls () {
      return this.getGruppenUrls
    }
  },
  methods: {
    ...mapActions({
      showHeader: 'showHeader'
    })
  },
  watch: {
    $route (to) {
      document.title = `Namaste Nepal  - ${to.meta.title}`
      const link = document.querySelector("[rel='icon']")
      link.setAttribute('href', to.meta.icon)
    }
  }

}
</script>
<style scoped>
.moveUp-enter-active{
    animation: fadeIn 2s ease-in;
  }
  @keyframes fadeIn{
    0% {
      opacity: 0;
    }
    25% {
      opacity: 0.25;
    }
    50% {
      opacity: 0.5;
    }
    75% {
      opacity: 0.80;
    }
    100%{
      opacity: 1;
    }
  }
  .moveUp-leave-active{
    animation: moveUp 0.4s ease-in;
  }
  .slide-enter-active
  .slide-leave-active{
    transition: 1s transform 1s;
     animation: fadeIn 1s ease-in;
  }
  .slide-enter
  .slide-leave-to{
    opacity: 0;
    transform: translateX(-30%);
    animation: fadeIn 1s ease-in;
  }
</style>
